import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START, TEXTS } from '../Utils/constants'

export default class TeamsStore extends FetchBase {
  @observable projectAllTeamUsersLoader = false
  @observable projectAllTeamUsers = []
  @observable projectAllTeamUsersTotal = 0

  @observable mediaCentericProjectTeamLoader = false
  @observable mediaCentricProjectTeams = []

  @observable customerProjectUsersLoader = false
  @observable customerProjectUsersPageNo = DEFAULT_PAGE_START
  @observable customerProjectUsersTotal = 0
  @observable customerProjectUsers = []

  @observable mediaCentricProjectUsersLoader = false
  @observable mediaCentricProjectUsersPageNo = DEFAULT_PAGE_START
  @observable mediaCentricProjectUsersTotal = 0
  @observable mediaCentricProjectUsers = []
  @observable isUserAssignedMII = false
  @observable mIIProjectUsersError = false
  @observable mIIProjectUsersErrorMessage = TEXTS?.SOME_THING_WRONG

  @observable orderingCust = undefined
  @observable orderingCustBy = undefined

  @observable projectTeam = []
  @observable projectTeamLoader = false

  @observable remaingUsersList = []
  @observable assignTeamMembersLoader = false

  @observable excludedMediacentricUsers = []
  @observable excludedCustomerUsers = []
  @observable excludedUsersLoding = false

  @observable customerUsersSearchText = ''
  @observable mediacentricUsersSearchText = ''

  @observable cTeamFilters = {}
  @observable mTeamFilters = {}

  @observable assignTeamMembersAsOnsiteLeadLoader = false

  @observable ordering = undefined
  @observable orderingBy = undefined

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    if (value === 'name') {
      value = 'fullName'
    }
    this.orderingBy = value
  }

  @action.bound
  setMediacentricTeamFilters = (filters = {}) => {
    this.mTeamFilters = filters
  }

  @action.bound
  setMediacentricUsersSearchText = (value = '') => {
    this.mediacentricUsersSearchText = value
  }

  @action.bound
  setMediaCentricUsersPageNo = (pageNo = DEFAULT_PAGE_START) => {
    this.mediaCentricProjectUsersPageNo = pageNo
  }

  @action.bound
  setOrderingCustomer = (value = undefined) => {
    this.orderingCust = value
  }

  @action.bound
  setOrderingCustomerBy = (value = undefined) => {
    if (value === 'name') {
      value = 'fullName'
    }
    this.orderingCustBy = value
  }

  @action.bound
  setCustomerUsersSearchText = (value = '') => {
    this.customerUsersSearchText = value
  }

  @action.bound
  setCustomerTeamFilters = (filters = {}) => {
    this.cTeamFilters = filters
  }

  @action.bound
  setCustomerUSersPageNo = (pageNo = DEFAULT_PAGE_START) => {
    this.customerProjectUsersPageNo = pageNo
  }

  // all users for list
  @action.bound
  getAllTeamsForProject = async (projectId, signal) => {
    try {
      this.projectAllTeamUsersLoader = true
      let temp = {}
      temp['orderBy'] = 'isOnSiteLead'
      temp['ordering'] = 'DESC'
      let response = await this.post(
        API_ENDPOINTS.GET_TEAM,
        {
          projectId,
          pageLimit: 0,
          pageNo: 0,
          ...temp,
        },
        signal
      )
      if (response.status) {
        this.projectAllTeamUsers = response.data.users
        this.projectAllTeamUsersTotal = response.data.total
        return [response.status, response.data.users]
      }
      this.projectAllTeamUsers = []
      this.projectAllTeamUsersTotal = 0
      return [false, undefined]
    } catch (err) {
      this.projectAllTeamUsers = []
      this.projectAllTeamUsersTotal = 0
      return [false, undefined]
    } finally {
      this.projectAllTeamUsersLoader = false
    }
  }

  @action.bound
  getTeamsForMediacentric = async (projectId, signal) => {
    try {
      this.mediaCentericProjectTeamLoader = true
      let response = await this.post(
        API_ENDPOINTS.GET_TEAM,
        {
          projectId,
          customerUser: false,
          pageLimit: 0,
          pageNo: 0,
        },
        signal
      )
      if (response.status) {
        this.mediaCentricProjectTeams = response.data.users
        return [response.status, response.data.users]
      }
      this.mediaCentricProjectTeams = []
      return [false, undefined]
    } catch (err) {
      this.mediaCentricProjectTeams = []
      return [false, undefined]
    } finally {
      this.mediaCentericProjectTeamLoader = false
    }
  }

  @action.bound
  getUsersForMediacentricExportData = async (
    projectId,
    { exportFileType = 'csv' } = {}
  ) => {
    try {
      let options = this.getFilterOptionsForMediacentricUsers()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_PROJECTS_TEAM, {
        projectId,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getUsersForCustomersExportData = async (
    projectId,
    { exportFileType = 'csv' } = {}
  ) => {
    try {
      let options = this.getFilterOptionsForCustomerUsers()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_PROJECTS_TEAM, {
        projectId,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getFilterOptionsForMediacentricUsers = () => {
    let temp = {
      customerUser: false,
    }
    let keys = Object.keys(this.mTeamFilters || {})
    for (let filter of keys) {
      if (this.mTeamFilters[filter] !== undefined) {
        temp[filter] = this.mTeamFilters[filter]
      }
    }
    this.mediacentricUsersSearchText &&
      (temp['search'] = this.mediacentricUsersSearchText)

    if (this.ordering) {
      temp['ordering'] = this.ordering
      temp['orderBy'] = this.orderingBy
    }

    return temp
  }

  @action.bound
  getFilterOptionsForCustomerUsers = () => {
    let temp = {
      customerUser: true,
    }
    let keys = Object.keys(this.cTeamFilters || {})
    for (let filter of keys) {
      if (this.cTeamFilters[filter] !== undefined) {
        temp[filter] = this.cTeamFilters[filter]
      }
    }

    this.customerUsersSearchText &&
      (temp['search'] = this.customerUsersSearchText)
    if (this.orderingCust) {
      temp['ordering'] = this.orderingCust
      temp['orderBy'] = this.orderingCustBy
    }
    return temp
  }

  // pagination wise users
  @action.bound
  getUsersForMediacentric = async (projectId) => {
    try {
      this.mediaCentricProjectUsersLoader = false
      let options = this.getFilterOptionsForMediacentricUsers() || {}
      let response = await this.post(API_ENDPOINTS.GET_TEAM, {
        projectId,
        customerUser: false,
        pageNo: Math.max(this.mediaCentricProjectUsersPageNo - 1, 0),
        ...options,
      })
      if (response.status) {
        this.mediaCentricProjectUsers = response.data.users
        this.mediaCentricProjectUsersTotal = response.data.total
        this.isUserAssignedMII = response.isUserAssigned
        return [response.status, response.data.users]
      }
      this.mediaCentricProjectUsers = []
      this.isUserAssignedMII = false
      return [false, undefined]
    } catch (err) {
      this.mediaCentricProjectUsers = []
      this.mIIProjectUsersError = true
      this.mIIProjectUsersErrorMessage = err?.message || TEXTS?.SOME_THING_WRONG
      return [false, undefined]
    } finally {
      this.mediaCentricProjectUsersLoader = false
    }
  }

  @action.bound
  getUsersForCustomer = async (projectId, signal) => {
    try {
      this.customerProjectUsersLoader = true
      let options = this.getFilterOptionsForCustomerUsers()
      let response = await this.post(
        API_ENDPOINTS.GET_TEAM,
        {
          projectId,
          customerUser: true,
          pageNo: Math.max(this.customerProjectUsersPageNo - 1, 0),
          ...options,
        },
        signal
      )
      if (response.status) {
        this.customerProjectUsers = response.data.users
        this.customerProjectUsersTotal = response.data.total
        return [response.status, response.data.users]
      }
      this.customerProjectUsers = []
      return [false, undefined]
    } catch (err) {
      this.customerProjectUsers = []
      return [false, undefined]
    } finally {
      this.customerProjectUsersLoader = false
    }
  }

  @action.bound
  getProjectTeam = async (projectId, signal) => {
    try {
      this.projectTeamLoader = true
      let response = await this.post(
        API_ENDPOINTS.GET_TEAM,
        {
          projectId,
          pageLimit: 0,
        },
        signal
      )
      if (response.status) {
        this.projectTeam = response.data.users
        return [response.status, response.data.users]
      }
      this.projectTeam = []
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectTeamLoader = false
    }
  }

  @action.bound
  removeTeamMembers = async (projectId, values) => {
    try {
      let { userId } = values
      if (userId) {
        if (!Array.isArray(userId)) {
          userId = [userId]
        }
      } else {
        userId = []
      }
      let response = await this.post(API_ENDPOINTS.DELETE_TEAM_MEMBER, {
        projectId,
        userId,
      })
      if (response.status) {
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  assignTeamMembers = async (projectId, values = {}) => {
    try {
      this.assignTeamMembersLoader = true
      let response = await this.post(API_ENDPOINTS.ASSIGN_TEAM_MEMBERS, {
        projectId,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.assignTeamMembersLoader = false
    }
  }

  @action.bound
  updateUserProjectRoleLocally = (id, newValue) => {
    if (!newValue?.id) {
      return
    }
    this.mediaCentricProjectUsers = (this.mediaCentricProjectUsers || []).map(
      (user) => {
        if (user.id === id) {
          user.projectRole = {
            id: newValue.id,
            name: newValue.name,
          }
        }
        return user
      }
    )
  }

  @action.bound
  updateUserProjectRole = async (userId, values) => {
    try {
      this.addActionItemLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_USER_PROJECT_ROLE, {
        userId,
        ...values,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addActionItemLoader = false
    }
  }

  @action.bound
  getRemainingUsersForProject = async (projectId) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.GET_REMAING_USERS_FOR_PROJECT,
        {
          projectId,
        }
      )
      if (response.status) {
        this.remaingUsersList = response.data
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  changeRemainingTeamMembers = (values) => {
    if (values?.length) {
      this.remaingUsersList = (this.remaingUsersList || []).filter(
        (user) => !(values || []).includes(user?.id)
      )
    }
  }

  @action.bound
  getExcludedMediacentricUsers = async (projectId) => {
    try {
      this.excludedUsersLoding = true
      let response = await this.get(API_ENDPOINTS.EXCLUDED_MEDIACENTRIC_USERS, {
        projectId,
        pageLimit: 0,
      })
      if (response.status) {
        this.excludedMediacentricUsers = response.data?.mediaCentricUsers || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.excludedUsersLoding = false
    }
  }

  @action.bound
  getExcludedCustomerUsers = async (projectId) => {
    try {
      this.excludedUsersLoding = true
      let response = await this.get(API_ENDPOINTS.EXCLUDED_CUSTOMER_USERS, {
        projectId,
        pageLimit: 0,
      })
      if (response.status) {
        this.excludedCustomerUsers = response.data?.excludedCustomerUser || []
        return [true, undefined]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.excludedUsersLoding = false
    }
  }

  @action.bound
  assignTeamMembersAsOnsiteLead = async (projectId, makeOnSiteLead) => {
    try {
      this.assignTeamMembersAsOnsiteLeadLoader = true
      let response = await this.post(
        API_ENDPOINTS.ASSIGN_TEAM_MEMBERS_AS_ONSITE_LEAD,
        {
          projectId: projectId,
          makeOnSiteLead,
        }
      )
      if (response.status) {
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.assignTeamMembersAsOnsiteLeadLoader = false
    }
  }

  @action.bound
  resetCustomerFilterForm = () => {
    this.cTeamFilters = {}
  }

  @action.bound
  resetMediacentricFilterForm = () => {
    this.mTeamFilters = {}
  }

  @action.bound
  resetStore = () => {
    this.projectAllTeamUsersLoader = false
    this.projectAllTeamUsers = []
    this.projectAllTeamUsersTotal = 0
    this.mediaCentericProjectTeamLoader = false
    this.mediaCentricProjectTeams = []
    this.customerProjectUsersLoader = false
    this.customerProjectUsersPageNo = DEFAULT_PAGE_START
    this.customerProjectUsersTotal = 0
    this.customerProjectUsers = []
    this.orderingCust = undefined
    this.orderingCustBy = undefined
    this.mediaCentricProjectUsersLoader = false
    this.mediaCentricProjectUsersPageNo = DEFAULT_PAGE_START
    this.mediaCentricProjectUsersTotal = 0
    this.mediaCentricProjectUsers = []
    this.isUserAssignedMII = false
    this.mIIProjectUsersError = false
    this.mIIProjectUsersErrorMessage = TEXTS?.SOME_THING_WRONG
    this.projectTeam = []
    this.projectTeamLoader = false
    this.remaingUsersList = []
    this.assignTeamMembersLoader = false
    this.excludedMediacentricUsers = []
    this.excludedCustomerUsers = []
    this.excludedUsersLoding = false
    this.customerUsersSearchText = ''
    this.mediacentricUsersSearchText = ''
    this.cTeamFilters = {}
    this.mTeamFilters = {}
    this.assignTeamMembersAsOnsiteLeadLoader = false

    this.ordering = undefined
    this.orderingBy = undefined
  }
}
